/** @format */
import { PleaseWait } from '../../../../../../Components/Loaders/PleaseWait'
import Checkbox from '../../../../../../Components/Checkbox/Checkbox'
import React from 'react'

export const SupplyCategories = ({
  disabled,
  isBusy,
  supplyCategoriesToSelect,
  onCheckSupplyCategory,
  prefix,
}) => {
  const handleOnCheckSupplyCategory = (supplyCategory, checkValue) => {
    const com = [...supplyCategoriesToSelect].map(comm => {
      if (comm.id === supplyCategory.id) {
        return { ...comm, checked: checkValue }
      }
      return comm
    })

    onCheckSupplyCategory(com)
  }

  return (
    <div className="px-4">
      {isBusy ? (
        <PleaseWait />
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {supplyCategoriesToSelect.map(supplyCategory => (
            <li
              key={supplyCategory.id}
              style={{ listStyle: 'none' }}
              className=" d-flex align-items-center"
            >
              <Checkbox
                id={`${prefix ? prefix : 'com'}-${supplyCategory.id}`}
                checked={supplyCategory.checked}
                disabled={disabled}
                margined
                onCheck={c => {
                  handleOnCheckSupplyCategory(supplyCategory, c)
                }}
              />
              <label
                htmlFor={`${prefix ? prefix : 'com'}-${supplyCategory.id}`}
                className={`fw-normal ms-2 cursor-pointer ${
                  supplyCategory.checked ? 'text-primary fw-bold' : ''
                }`}
              >
                {supplyCategory?.description}
              </label>
            </li>
          ))}
        </div>
      )}
    </div>
  )
}
